export function confirmFormSubmit(event) {
    let message = "Confirmar eliminación del registro";

    if (!confirm(message))
        event.preventDefault();
}

export function print() {
    const content = document.querySelector(".impresion").innerHTML,
    printWindow = window.open("", "_blank"),
    currentUrl = window.location.href;

    if(printWindow) {
        printWindow.document.write("<!DOCTYPE html><html><head><title>Obra</title>");
        const links = document.head.querySelectorAll('link, meta');
        links.forEach(link => {
            printWindow.document.write(link.outerHTML);
        });
        printWindow.document.write(`</head><body class="pm-display obra obra-pagina"><img src="${window.location.origin}/resources/assets/images/poesia-prosa-logo.svg" class="logo-print" />`);
        printWindow.document.write(content);
        printWindow.document.write(`<p><b>Fuente: </b>${currentUrl}</p></body></html>`);
        printWindow.document.close();

        printWindow.addEventListener("load", () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        });
    } else {
        alert("Para poder imprimir el contenido, necesita dar permiso al navegador para abrir la ventana emergente.");
    }

    //document.body.innerHTML = content;
    //window.print();
    //document.body.innerHTML = originalContent;
}